import Layout from 'components/layout'

const App = () => (
  <Layout>
    Nav component found in <code>src/components/navbar.tsx</code>
  </Layout>
)

export default App
